import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import i18n from '../../../../../translations/i18n';
import { formatLocaleDate } from '../../../../../helpers/dateHelpers';
import { AgentBadge } from '../../../../../components/AgentBadge';
import { truncateText } from '../../../../../helpers/textHelper';

export const getColumns = (): GridColDef[] => [
  {
    field: 'performedAt',
    headerName: i18n.t('entities:common.date'),
    width: 150,
    valueGetter: (date: string) => formatLocaleDate(date),
    hideable: false,
  },
  {
    field: 'summary',
    headerName: i18n.t('entities:activityLog.summary'),
    valueGetter: (summary: string) => truncateText(summary, 150),
    flex: 1,
    minWidth: 150,
    hideable: false,
    sortable: false,
  },
  {
    field: 'agent',
    headerName: i18n.t('entities:activityLog.agent'),
    width: 200,
    renderCell: (params) => {
      const row = params.row;

      return <AgentBadge agent={row.agent} />;
    },
    hideable: false,
    sortable: false,
  },
];
